import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import navigationReducer from "./navigationSlice.js";
import profileCountReducer from "./profileCountSlice";
import completionReducer from "./completionSlice";   // ⬅️ add this
import messagecountReducer from "./messageCountSlice.js"

const store = configureStore({
  reducer: {
    user: userReducer,
    navigation: navigationReducer,
    profileCount: profileCountReducer,
    messageCount:messagecountReducer,
    completion: completionReducer,  // ⬅️ add reducer here
  },
});

export default store;
